<i18n src="@/i18n/shared/support/list.json"></i18n>
<i18n src="@/i18n/enums/support_urgency.json"></i18n>
<template>
	<Page
		:title="$t('support_list.title')"
		icon="fa fa-user-headset text-turquoise"
		class="min-h-full flex flex-col"
		:titleLoading="isBgLoading"
		@title-action="handleLoad(true)">
		<!-- Action !-->
		<template v-slot:after-title>
			<!-- Create !-->
			<CreateButton v-if="hasData" :to="{ name: 'tickets.create' }" class="ml-auto"/>
		</template>
		<!-- Advanced Filter !-->
		<AdvancedFilter v-show="view === 'list'" v-model="filter.advanced" @apply="handleFilter">
			<AdvancedFilterOption field="shipment.tracking_code" label="Rastreio de remessa" type="text" :operators="['eq', 'ne']"/>
			<AdvancedFilterOption field="partner_id" label="Parceiro" type="partner" :operators="['eq', 'ne']"/>
			<AdvancedFilterOption field="department_id" label="Setor" type="department" :operators="['eq', 'ne']"/>
			<AdvancedFilterOption field="user_id" label="Colaborador" type="user" :operators="['eq', 'ne']"/>
			<AdvancedFilterOption field="urgency" label="Prioridade" type="select" :options="urgencyOptions" icon="fal fa-exclamation-circle"/>
			<AdvancedFilterOption field="support_subject_id" label="Assunto" type="support_subject"/>
			<AdvancedFilterOption field="created_at" label="Aberto em" type="date" :operators="['eq', 'ge', 'le']"/>
			<AdvancedFilterOption field="stale_hours" label="Sem movimentação" type="select" :options="staleOptions" icon="fal fa-clock"/>
		</AdvancedFilter>
		<!-- Status Filters !-->
		<div class="flex items-center h-12">
			<FilterStatusBar v-show="view === 'list'" :page="page" :selected="filter.status" @select="handleSelectStatusFilter"/>
			<!--			<div class="flex space-x-2 ml-auto items-center">-->
			<!--				<button type="button" @click="view = 'list'" :class="view === 'list' && 'text-turquoise'">-->
			<!--					<i class="fal fa-list"></i>-->
			<!--				</button>-->
			<!--				<button type="button" @click="view = 'card'" :class="view === 'card' && 'text-turquoise'">-->
			<!--					<i class="fal fa-cards-blank"></i>-->
			<!--				</button>-->
			<!--			</div>-->
		</div>
		<template v-if="view === 'list'">
			<!-- Card !-->
			<Card title="Lista de tickets">
				<template v-if="hasData">
					<!-- Table !-->
					<AutoTable v-bind="table()" v-model="page.data" @sort="handleSort" @row-click="handleSelected" @row-context="handleContextRow">
						<template #col-shipment="{ data: { row } }">
							<p>{{ $data_get(row.shipment, 'tracking_code') }}</p>
						</template>
						<template #col-subject="{ data: { row } }">
							<p>{{ $localize(row.subject, 'title_locale') }}</p>
							<div class="mt-px inline-flex space-x-2 text-xs">
								<p class="inline-flex space-x-2">
									<span>
										<i class="fal fa-user text-xs"></i>
									</span>
									<span>{{ row.created_by.name }}</span>
								</p>
								<p class="inline-flex space-x-2">
									<span>
										<i class="fal fa-arrow-right text-xs"></i>
									</span>
									<span>{{ destinationAddresses(row) }}</span>
								</p>
							</div>
						</template>
						<template #col-status="{ data: { row } }">
							<!-- {{ row.support_ticket_status }} -->
							<SupportTicketStatusBadge :support_ticket="row"/>
						</template>
						<!-- Ultima movimentacao: destaca os chamados sem resposta ha muito tempo !-->
						<template #col-last_message_at="{ data: { row, value } }">
							<p :class="row.is_unanswered && 'text-red-600 font-medium'"
							   :title="row.is_unanswered ? unansweredLabel(row) : null">
								<span>{{ value }}</span>
								<i v-if="row.is_unanswered" class="fal fa-clock ml-1"></i>
							</p>
						</template>
					</AutoTable>
					<Pagination v-bind="page.meta" @select-page="handleSelectPage"/>
				</template>
				<!-- / Table !-->
				<!-- Empty Filters !-->
				<template v-else-if="hasFilter">
					<p class="p-4 text-base text-center">
						{{ $t('support_list.no_results_for_filter') }}
					</p>
				</template>
				<!-- Empty !-->
				<template v-else>
					<div class="p-4 h-96 space-y-8 flex flex-col text-base justify-center items-center">
						<p>{{ $t('support_list.empty') }}</p>
						<CreateButton :to="{ name: 'tickets.create' }"/>
					</div>
				</template>
				<!-- / Table !-->
			</Card>
			<!-- / Card !-->
		</template>
		<template v-else>
			<!--			{{ page.data }}-->
			<KanbanContainer class="">
				<KanbanStage title="Teste" :data="stageData"/>
			</KanbanContainer>
		</template>
		<!-- ContextMenu !-->
		<SupportTicketContextMenu v-bind="contextMenu" v-model="showContextMenu" @isLoading="handleLoad(true)"/>
	</Page>
</template>

<script>
import Mixin from "./mixins/index.js"

import Page from "@/components/Page.vue"
import Card from "@/components/Card.vue"
import Loading from "@/components/Loading.vue"
import AutoTable from "@/components/AutoTable2.vue"
import Pagination from "@/components/Pagination.vue"
import TableFilter from "@/components/TableFilter.vue"
import Dropdown from "@/components/Dropdown.vue"

import FormLine from "@/components/FormLine.vue"
import FormRadio from "@/components/FormRadio.vue"
import FormInput from "@/components/FormInput.vue"
import FormSelect from "@/components/FormSelect.vue"
import FormDatePicker from "@/components/FormDatePicker.vue"
import SupportTicketStatusBadge from "@/domain/support_tickets/SupportTicketStatusBadge.vue"
import FilterStatusBar from "./partials/FilterStatusBar.vue"
import AdvancedFilter from "@/components/AdvancedFilter.vue"
import AdvancedFilterOption from "@/components/AdvancedFilterOption.vue"
import CreateButton from "@/components/CreateButton.vue"
import AnvisaSolicitaContextMenu from "@/domain/anvisa_solicita/AnvisaSolicitaContextMenu.vue";
import SupportTicketContextMenu from "@/domain/support_tickets/SupportTicketContextMenu.vue";
import KanbanContainer from "@/components/KanbanContainer.vue";
import KanbanStage from "@/components/Kanban/KanbanStage.vue";

import {options as SupportUrgencyOptions} from "@/enums/support_urgency.js"

export default {
	name: "IndexPage",
	mixins: [Mixin],
	components: {
		KanbanStage,
		KanbanContainer,
		SupportTicketContextMenu,
		CreateButton,
		Page,
		Card,
		AutoTable,
		Pagination,
		TableFilter,
		SupportTicketStatusBadge,
		FilterStatusBar,
		AdvancedFilter,
		AdvancedFilterOption
	},
	data() {
		return {
			showContextMenu: false,
			contextMenu: {
				supportTicket: null,
				target: null
			},
			view: 'list',
			stageData: [
				{
					id: 1,
					title: "Teste 1",
				},
				{
					id: 2,
					title: "Teste 2",
				},
				{
					id: 3,
					title: "Teste 3",
				}
			]
		}
	},
	computed: {
		/**
		 * Check if has data
		 * @returns {boolean}
		 */
		hasData() {
			return this.page?.meta?.total > 0
		},
		hasFilter() {
			return this.hasSearchFilter
		},
		/**
		 * Ticket priorities, translated
		 * @returns {Object[]}
		 */
		urgencyOptions() {
			return translateEnum(this, SupportUrgencyOptions, 'support_urgency.')
		},
		/**
		 * Tickets idle for X hours
		 * @returns {Object[]}
		 */
		staleOptions() {
			return [
				{id: 24, label: this.$t('support_list.filter.stale_hours', {hours: 24})},
				{id: 72, label: this.$t('support_list.filter.stale_hours', {hours: 72})},
				{id: 168, label: this.$t('support_list.filter.stale_days', {days: 7})},
			]
		},
		actions() {
			return []
		}
	},
	methods: {
		handleLoad(background) {
			this.load(background)
		},
		/**
		 * Handle selected row
		 * @param row
		 */
		handleSelected(e, row) {
			if (e.metaKey || e.ctrlKey) {
				return window.open(this.$router.resolve({name: 'tickets.show', params: {id: row.id}}).href, '_blank')
			}

			this.$router.push({name: 'tickets.show', params: {id: row.id}})
		},
		/**
		 * Handle select page
		 * @param page
		 */
		handleSelectPage(page) {
			this.filter.page = page
			this.syncUrl()
			this.load()
		},
		/**
		 * Handle select filter status
		 * @param evt
		 */
		handleSelectStatusFilter(evt) {
			this.filter.status = evt
			this.reload()
		},
		/**
		 * Handle busca / filtros da barra
		 */
		handleFilter() {
			this.reload()
		},
		/**
		 * Handle ordenação das colunas
		 * O AutoTable emite o prefixo invertido em relação ao backend ('-' = desc lá),
		 * então normalizamos aqui para a seta da coluna bater com a ordem retornada.
		 * @param evt
		 */
		handleSort(evt) {
			this.filter.sort = (evt.sort || '')
				.split(',')
				.filter(Boolean)
				.map(item => item.startsWith('-') ? item.substring(1) : `-${item}`)
				.join(',') || null

			this.reload()
		},
		handleContextRow(e) {
			e.evt.stopPropagation()
			e.evt.preventDefault();

			this.$set(this, 'contextMenu', {
				supportTicket: this.page.data[e.rowIndex],
				target: e.evt.target.closest('tr')
			})

			this.showContextMenu = true
		},
		/**
		 * Ha quanto tempo o chamado esta sem resposta, em horas ate 48h e em dias depois disso
		 * @param row
		 * @returns {string}
		 */
		unansweredLabel(row) {

			const hours = row.unanswered_hours

			if (!filled(hours)) return ''

			return hours >= 48
				? this.$t('support_list.unanswered_days', {days: Math.floor(hours / 24)})
				: this.$t('support_list.unanswered_hours', {hours})
		},
		destinationAddresses(row) {
			return row.addresses.map(item => {
				if (item.address_type === 'user') {
					return item.label
				}

				return this.$localize(item.label)
			}).join(', ')
		},
	},
	mounted() {
		this.init()
	}
}
</script>
